import { styled } from '../../Utilities';
import { TooltipHostBase } from './TooltipHost.base';
import { getStyles } from './TooltipHost.styles';
export var TooltipHost = styled(TooltipHostBase, getStyles, undefined, {
  scope: 'TooltipHost'
});